import type { EconHeaderCountdownPulseMode } from "../../lib/econ-header-countdown";

const STYLE_ID = "econ-header-countdown-pill-keyframes";

export function ensureEconHeaderCountdownStyles() {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes econ-header-actual-pulse {
      0%, 100% { box-shadow: 0 0 0 0 color-mix(in srgb, var(--econ-rim) 28%, transparent); }
      50% { box-shadow: 0 0 0 5px color-mix(in srgb, var(--econ-rim) 0%, transparent); }
    }
    @keyframes econ-header-countdown-threshold-wash {
      0% { opacity: 0; background: transparent; }
      24% { opacity: 0.42; background: color-mix(in srgb, var(--econ-pulse-color) 42%, transparent); }
      62% { opacity: 0.22; background: color-mix(in srgb, var(--econ-pulse-color) 24%, transparent); }
      100% { opacity: 0; background: transparent; }
    }
    @keyframes econ-header-countdown-awaiting-wash {
      0%, 100% { opacity: 0.14; background: color-mix(in srgb, var(--econ-pulse-color) 18%, transparent); }
      50% { opacity: 0.48; background: color-mix(in srgb, var(--econ-pulse-color) 48%, transparent); }
    }
    @keyframes econ-header-countdown-release-fade {
      0% { opacity: 0.38; background: color-mix(in srgb, var(--econ-pulse-color) 42%, transparent); }
      100% { opacity: 0; background: transparent; }
    }
    @keyframes econ-header-actual-value-in {
      0% { opacity: 0; transform: translateY(3px); }
      100% { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);
}

export function countdownPulseColor(secondsRemaining: number) {
  if (secondsRemaining <= 10) return "#f97316";
  if (secondsRemaining <= 60) return "#eab308";
  return "#6b7280";
}

export function getCountdownOverlayAnimation({
  pulseMode,
  pulseKey,
  releaseFadeKey,
}: {
  pulseMode: EconHeaderCountdownPulseMode;
  pulseKey: number;
  releaseFadeKey: number;
}) {
  if (pulseMode === "awaiting") {
    return {
      key: `awaiting-${releaseFadeKey}`,
      animation:
        "econ-header-countdown-awaiting-wash 1100ms ease-in-out infinite",
    };
  }
  if (releaseFadeKey > 0) {
    return {
      key: `release-${releaseFadeKey}`,
      animation: "econ-header-countdown-release-fade 760ms ease-out forwards",
    };
  }
  return {
    key: `threshold-${pulseKey}`,
    animation:
      pulseKey > 0
        ? "econ-header-countdown-threshold-wash 980ms cubic-bezier(0.32, 0.72, 0, 1) 1"
        : undefined,
  };
}
